import { createApp } from "vue";
import App from "./App.vue";
//import App from "./LoginU.vue";
import router from "./router";


import './assets/style.css';

import "@fortawesome/fontawesome-free/js/all";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const app = createApp(App);
//app.config.globalProperties.$httphttp = 'xyz' variable global
app.use(VueSweetalert2);
app.use(router).mount("#app");
//createApp(App).use(VueSweetalert2);
//createApp(App).use(router).mount("#app");